import dayjs from '@/utils/dayjs';
import Constants from '@/constants/const';
/**
 * 获取dayjs对象，支持多语言
 * @param input
 */
export const getDayjsObject = (input: string | number, locale: string) => {
  const lng = locale === 'zh' ? 'zh-cn' : locale === 'zht' ? 'zh-tw' : locale;
  return dayjs(input).locale(lng);
};

/**
 * 兼容日文下格式化周的字符串会出现样式问题
 * @param lang 语言
 * @param date 需要格式化的日期
 * @returns string
 */
export const compatibleDayJsFormat = (lang: string, date: string) => {
  if (!date) return '';
  //日文下展示兼容
  const dateFormat = lang === Constants.LANGUAGE_JA ? 'dddd MM/DD/YYYY' : 'ddd MM/DD/YYYY';
  return getDayjsObject(date, lang).format(dateFormat);
};

export const formatDate = (date: string | number, lang?: string, format?: string) => {
  if (!date) return '';
  const dateFormat = format ? format : 'ddd, MM/DD';
  return getDayjsObject(date, lang).format(dateFormat);
};
